<template>
  <PageOne/>
  <PageTwo/>
  <PageThree/>
</template>

<script>
import PageOne from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/FooladKaveh/PageOne.vue';
import PageTwo from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/FooladKaveh/PageTwo.vue';
import PageThree from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/FooladKaveh/PageThree.vue';

export default {
  components: {
    PageOne,
    PageTwo,
    PageThree,
  },
  data() {
    return {}
  }
}
</script>
